import React, { useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import styled from '@emotion/styled';
import useTranslation from 'Hooks/useTranslation';
import SideBarContainer from 'Containers/SideBarContainer';
import { PageHeader, SectionGrid, SectionGroup, SectionCard } from 'Components/ui';
import Alert from 'Components/Alert';
import useInformation from './Hooks/useInformation';

// Rejilla y tarjetas se miden solas; lo único que pone la página es el aire de
// alrededor. La versión anterior colocaba las tarjetas con `Grid md={3}` y
// `space-evenly`, que las encimaba en cuanto el contenido crecía.
const PageBody = styled.div({
  flex: 1,
  padding: '34px 40px 64px',
});

const Groups = styled.div({
  display: 'flex',
  flexDirection: 'column',
  gap: 28,
});

/**
 * Hub de definición de cursos, en dos grupos: la cascada de obligatorios
 * —empresa, departamento y puesto, de lo más amplio a lo más específico— y los
 * opcionales, que no obligan a nadie y por eso van aparte.
 */
export default function DefinitionCourses() {
  const { t2 } = useTranslation('DefinitionCourse');
  const { sections, goTo } = useInformation();
  const location = useLocation();
  const [open, setOpen] = useState(false);

  useEffect(() => {
    if (location?.state?.update) {
      setOpen(true);
    }
  }, []);

  const mandatory = sections.filter(section => section.group === 'mandatory');
  const optional = sections.filter(section => section.group === 'optional');

  const cardProps = section => ({
    icon: section.icon,
    iconBg: section.iconBg,
    iconColor: section.iconColor,
    title: t2(section.titleKey),
    description: t2(section.descriptionKey),
    ctaLabel: t2('CardCta'),
    count: section.count,
    emptyLabel: t2('CardEmptyCount'),
    onClick: () => goTo(section.route),
  });

  return (
    <SideBarContainer>
      <PageBody>
        <PageHeader title={t2('Title')} description={t2('Subtitle')} />
        <Groups>
          <SectionGroup label={t2('GroupMandatory')}>
            <SectionGrid columns={3}>
              {mandatory.map(section => (
                <SectionCard key={section.id} {...cardProps(section)} />
              ))}
            </SectionGrid>
          </SectionGroup>

          <SectionGroup label={t2('GroupOptional')}>
            {optional.map(section => (
              <SectionCard key={section.id} wide {...cardProps(section)} />
            ))}
          </SectionGroup>
        </Groups>
      </PageBody>
      <Alert message={t2('OnSuccessMessage')} open={open} setOpen={setOpen} />
    </SideBarContainer>
  );
}
